var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "draggableEle",
    staticClass: "drag-container",
    on: {
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };